<template>
  <v-container fluid>
        <div v-if="authenticated">
          <v-layout align-start wrap justify-start>
            <v-flex xs12>
              <span class="dHeading">Re:Data</span>
              <KilnSelect complabel="Data for"></KilnSelect>
              <RangeSelect v-on:window-closed="loadData()"></RangeSelect>
              <v-btn icon @click="loadData()"><v-icon>refresh</v-icon></v-btn>
            </v-flex>
           <v-flex xs12>
                <v-card elevation="0">
                  <div>
                    <ve-line :data="chartData" :settings="chartSettings" :extend="extend"></ve-line>
                  </div>
                </v-card>
            </v-flex>
            <v-snackbar v-model="snackbar" :bottom="y === 'bottom'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="timeout" :top="y === 'top'" :vertical="mode === 'vertical'" color='warning'>
                {{ text }}
                <v-btn color="black" flat @click="snackbar=false" round>Close</v-btn>
            </v-snackbar>
        </v-layout>
      </div>
  </v-container>
</template>

<script>
import axios from "axios"
import { mapState, mapGetters } from 'vuex'
import { format } from 'date-fns'
import VeLine from 'v-charts/lib/line.common'
import KilnSelect from './KilnSelectComponent'
import RangeSelect from './DateRangeSelectComponent'

  export default {
      data() {
        this.chartSettings = {
          metrics: ['TC1-F', 'TC2-F'],
          dimension: ['T']
        }
        this.extend = {
          'xAxis.0.axisLabel.rotate': 90
        }
        return {
            urlTc: "/thermocouple-services/tc/list/tc/",
            urlData: "/thermocouple-services/tc/chart/",
            snackbar: false,
            y: 'top',
            x: 'left',
            mode: '',
            timeout: 5000,
            text: '',
            chartData: {
        rows: []
      }
        }
    },
    components: {
        VeLine,
        KilnSelect,
        RangeSelect
    },
    methods: {
        loadData() {
            if ( this.getSelectedLocation().name === 'Select' ) {
                this.text = 'Select a location first'
                this.snackbar = true;
            } else if ( this.getSelectedKiln().name === 'Select' ) {
                this.text = 'Select a kiln first'
                this.snackbar = true;
            }  else {
                var url         = this.secureHost + this.urlTc + this.getSelectedKiln().id,
                    acctHeader  = this.getAccountHeader(),
                    userHeader  = this.getUserHeader(),
                    acctId      = this.getLoggedInUser().accountId,
                    userId      = this.getLoggedInUser().id;
                axios({ method: "GET", "url": url, "headers": { "Accept": "application/json", acctHeader: acctId, userHeader: userId, "Authorization": this.getAuthToken() } }).then(result => {
                        this.metrics = new Array(result.data.thermocouples.length);
                        for ( var idx = 0; idx < result.data.thermocouples.length; idx++ ) {
                            this.metrics[idx] = result.data.thermocouples[idx].tcId + '-' + result.data.thermocouples[idx].units;
                        }
                    }).catch(error => {
                        this.text = 'Error retrieving thermocouple list'
                        this.snackbar = true;
                    });
                url = this.secureHost + this.urlData + this.getSelectedLocation().name + "/" + this.getSelectedKiln().name + "/" + this.range[0] + " 00:00:00/" + this.range[1] + " 23:59:59";
                axios({ method: "GET", "url": url, "headers": { "Accept": "application/json", acctHeader: acctId, userHeader: userId, "Authorization": this.getAuthToken() } }).then(result => {
                        this.chartData.rows = result.data.rows;
                    }).catch(error => {
                        this.text = 'Error retrieving kiln data'
                        this.snackbar = true;
                    });
            }
        },
        onDateRangeChange(range) {
          this.range = range;
        },
        ...mapGetters([
            'getLoggedInUser',
            'getSelectedLocation',
            'getSelectedKiln',
            'getAccountHeader',
            'getUserHeader',
            'getAuthToken'
        ])
      },
      computed: {
        ...mapState([
            'authenticated',
            'secureHost',
            'range'
        ])
    }
  }
</script>

<style scoped>
.dHeading {
    font-size: 20px;
    font-weight: bold
}
</style>
